import type { ElementModels } from "@kontent-ai/delivery-sdk";

export function getStatus(status?: ElementModels.MultipleChoiceOption, date?: Date) {

    if (status) {

        if (status.codename == 'no_status'){
            return '';
        }
        if (status.codename != 'auto') {
            return status.codename
        }
    }

    if (date) {

        if (date < new Date()) {
            return 'passed';
        }
        else {
            return 'upcoming';
        }
    }
    return '';
}

export function getStatusClass(status?: ElementModels.MultipleChoiceOption, date?: Date) {
    if (status) {

        if (status.codename != 'auto') {
            return status.codename
        }
    }

    if (date) {
        if (date < new Date()) {
            return 'held';
        }
        else if (date > new Date()) {
            return 'auto';
        }
    }
}